<template>
  <PCadastroSemSenha />
</template>

<script>
import PCadastroSemSenha from '@/components/p-cadastro-sem-senha/index.vue';

export default {
  components: {
    PCadastroSemSenha,
  },
};
</script>
